import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';

@Injectable()
export class InstallationRoadSurfacePluginService extends InspectionPluginService {
  private surfaceTypesKeys = [
    { value: 1, label: 'plugins.installationroadsurface.concrete' },
    { value: 2, label: 'plugins.installationroadsurface.gravel' },
    { value: 3, label: 'plugins.installationroadsurface.no-pavement' }
  ];

  private surfaceTypes = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getSurfaceTypes() {
    return this.surfaceTypes;
  }

  public updateRoadSurface(inspectionId: string, pointId: string, pluginId: string, surfaceType: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, surfaceType).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.surfaceTypes = [];
    this.copyTranslationValues(this.surfaceTypesKeys, this.surfaceTypes, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, surfaceType: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, surfaceType).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
